<script lang="ts">
    import { tooltip } from "../../../helper"
    import { _ } from "svelte-i18n"

    export let statusSummary: OperationStatusSummary

    $: sType = statusSummary?.canceled ? (statusSummary?.canceled == 100 ? "S" : "TS") : ""
</script>

<div class="states">
    <span
        class="state {{ '': 'grey', S: 'storno red', TS: 'teilstorno red' }[sType]}"
        use:tooltip="{{
            content: {
                '': $_('components.table.fields.cancellation.none'),
                S: $_('components.table.fields.cancellation.full'),
                TS: $_('components.table.fields.cancellation.partial'),
            }[sType],
        }}"
    >
        {sType}
    </span>
</div>
